import Service from '@/utils/request';

/**
 *城管一张图首页相关接口
 */
const IndexApi = {

    /**
     * 获取应急机库列表
     * @returns
     */
    getDockList: (params) => Service.get('/biz/emergency/resource/site', { params: { ...params } }),

    /**
     * 获取应急班组。 包含班组基础信息、成员列表、无人机列表、挂载列表、车两列表。
     * @returns
     */
    getTeamList: (params) => Service.get('/biz/emergency/resource/team', { params: { ...params } }),

    /**
     * 获取应急班组详情。
     * @param {id:班组id} params
     * @returns
     */
    getTeamDetail: (params) => Service.get(`/biz/emergency/team/getDetail/${params}`, { }),

    /**
     * 应急班组人员。 人员信息、位置、所属班组ID
     * @param {} params
     * @returns
     */
    getTeamUser: (params) => Service.get('/biz/emergency/resource/teamUser', params),

    /**
     * 获取今日案件列表
     * @param {status:状态} params
     * @returns
     */
    getTodayList: (params) => Service.get('/biz/emergency/case/todayList', { params: { ...params } }),

    /**
     * 地面摄像头。
     */
    getCamera: (params) => Service.get('/biz/emergency/resource/camera', { }),

    /**
     * 直播地址列表。 根据当前案件关联的设备，获取直播地址。要求设备已开启直播。
     * @param {caseId:案件id} params
     * @returns
     */
    getResourceLive: (params) => Service.get('/biz/emergency/resource/live', { params }),

    /**
     * 案件关联的文件列表。。
     * @param {caseId:案件id} params
     * @returns
     */
    getCaseFileList: (params) => Service.get('/biz/emergency/case/listFile', { params }),

    /**
     * 案件关联的历史视频列表。。
     * @param {caseId:案件id} params
     * @returns
     */
    getResourceVideoList: (params) => Service.get('/biz/emergency/resource/videoList', { params }),

    /**
     * 一键下发任务
     * @param { "params": { property1: {}, property2: {} }, longitude: 经度, latitude: 纬度, dockIds: 机库列表, teamIds: 班组列表 } params
     * @returns
     */
    AddDispactTask: (params) => Service.post('/biz/emergency/case/dispactTask', { ...params, appCode: 'YJ' }),

    /**
     * 新增案件
     * @param { "name": "名称", "location": "地址", "longitude": 经度, "latitude": 纬度, "area": "发生范围" } params
     * @returns
     */
    addCase: (params) => Service.post('/biz/emergency/case/add', { ...params, appCode: 'YJ' }),

    /**
     * 删除应急案件。
     * @param {id:案件id} params
     * @returns
     */
    delCase: (params) => Service.delete(`/biz/emergency/case/${params}`, { }),

    /**
     * 新增案件画布元素。
     *@returns /biz/emergency/resource/canvas/add
     */
    addResourceCanvas: (params) => Service.post('/biz/emergency/resource/canvas/add', { ...params, appCode: 'YJ' }),

    /**
     * 案件画布元素。 场景：每个案件单独绘制的点、线、面图形。
     * @param {caseId:案件id} params
     * @returns
     */
    getCaseCanvas: (params) => Service.get('/biz/emergency/resource/canvas', { params: { ...params } }),
    /**
     * 删除应急案件画布元素。
     * @param {ids:元素id} params
     * @returns
    */
    delCaseCanvas: (params) => Service.delete(`/biz/emergency/canvas/${params}`, { }),

    /**
     * 获取应急案件详情。
     * @param {id:案件id} params
     * @returns
     */
    getCaseInfo: (params) => Service.get(`/biz/emergency/case/${params}`, { }),

    /**
     * 获取应急案件日志列表。
     * @param {id:案件id} params
     * @returns
     */
    getCaseLogList: (params) => Service.get(`/biz/emergency/case/logList?id=${params.id}`, { }),

    /**
     * 应急班组统计。
     * @param
     * @returns
     */
    getTeamStatistic: (params) => Service.get('/biz/emergency/resource/teamStatistic', { params: { ...params } }),

    /**
     * 人员状态统计。。
     * @param
     * @returns
     */
    getTeamUserStatistic: (params) => Service.get('/biz/emergency/resource/teamUserStatistic', { params: { ...params } }),
    /**
     * 无人机状态共计。。
     * @param
     * @returns
     */
    getDroneStatistic: (params) => Service.get('/biz/emergency/resource/droneStatistic', { params: { ...params } }),
    /**
     * 设备状态统计。。
     * @param
     * @returns
     */
    getDeviceStatistic: (params) => Service.get('/biz/emergency/resource/deviceStatistic', { params: { ...params } }),
    /**
     * 车辆状态共计。。
     * @param
     * @returns
     */
    getCarStatistic: (params) => Service.get('/biz/emergency/resource/carStatistic', { params: { ...params } }),
};
export default {
    ...IndexApi,
};
